var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height"},[_c('LayoutVerticalCustom',{attrs:{"hasEditIcon":false,"verticalNavbarList":_vm.verticalNavbarList,"name":_vm.phaseDetails ? _vm.phaseDetails.name : ''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }